import React from 'react';
import { CTNIcon } from '@ctn/ui/components/ctn-icon';
import CTNButton from '@ctn/ui/components/ctn-button';
import CTNButtonGroup from '@ctn/ui/components/ctn-buttons-group';

import { useNavigate } from 'react-router-dom';

type NotificacionProps = {
	readonly code: number;
	readonly contentSuccess: {
		titulo: string;
		detalle: string;
	};
	readonly contentError: {
		titulo: string;
		detalle: string;
	};
};

const Notificacion: React.FC<NotificacionProps> = ({ code, contentSuccess, contentError }) => {
	const navigate = useNavigate();
	const isSuccess = code === 200;

	const handleBack = () => {
		if (isSuccess) {
			navigate('/');
		} else {
			window.location.reload();
		}
	};
	return (
		<div className="c-jt-notificacion">
			<div className="c-jt-notificacion__body">
				<CTNIcon
					icon={isSuccess ? 'okCircleOutline' : 'koCircleOutline'}
					color={isSuccess ? 'green-50' : 'red-50'}
					size="size-48"
				/>
				<p className="[ c-jt-notificacion__titl ] [ u-mt-8 ]">
					{isSuccess ? contentSuccess.titulo : contentError.titulo}
				</p>
				<p className="[ c-jt-notificacion__content ] [ u-mt-8 ]">
					{isSuccess ? contentSuccess.detalle : contentError.detalle}
				</p>
			</div>

			{!isSuccess && (
				<CTNButtonGroup align="center" className="u-mt-16">
					<CTNButton label="VOLVER" size="size-40" minWidth="240" onClick={handleBack} />
				</CTNButtonGroup>
			)}
		</div>
	);
};

export default Notificacion;
